import amplitude from "amplitude-js";
import environment from "./environment";

// docs: https://developers.amplitude.com/

let disableAnalytics = environment.name === "localhost";
//disableAnalytics = false;

export const initAnalytics = (appVersion?: string) => {
  if (disableAnalytics) return; // disable analytics on localhost

  amplitude.getInstance().init(environment.aplitudeAPIkey as string);

  if (appVersion) amplitude.getInstance().setVersionName(appVersion);
};

export const logOutUserAnalytics = () => {
  if (disableAnalytics) return; // disable analytics on localhost

  amplitude.getInstance().setUserId(null);
  //amplitude.getInstance().regenerateDeviceId();
};

export const logInUserAnalytics = (
  email: string,
  name: string,
  userId: string,
  appVersion: string
) => {
  if (disableAnalytics) return; // disable analytics on localhost

  var userProperties = {
    email,
    nombre: name,
    userId,
    appVersion,
  };

  amplitude.getInstance().setUserProperties(userProperties);
};

export const logEventAnalytics = (eventName: string, eventData?: unknown) => {
  if (disableAnalytics) return; // disable analytics on localhost

  amplitude.getInstance().logEvent(eventName, eventData);
};
